module.exports = require("./../../_gen/starling/events/TouchData");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/events/TouchData.js
// module id = 185
// module chunks = 0